define(function () {

    var Binding = function (controls) {
        this.controls = controls || [];
    };

    _.extend(Binding.prototype, {

        add: function (controls) {
            if (!_.isArray(controls)) { controls = [controls]; }
            this.controls.push.apply(this.controls, controls);
        },

        render: function () {
            _.each(this.controls, function (control) {
                this.renderControl(control);
            }, this);
            return this;
        },

        renderControl: function (control) {
            control.render().applyBindings().delegateEvents();

            if (control.options.preload) {
                control.preload();
            }
            return this;
        },

        remove: function () {
            // we must delete child controls at first
            _.each(this.controls.slice().reverse(), function (control) {
                this.removeControl(control);
            }, this);
            return this;
        },

        removeControl: function (control) {
            control.cancelBindings().remove();
            return this;
        },

        removeErrors: function () {
            _.invoke(this.controls, 'removeErrors');
            return this;
        }

    });

    return Binding;

});
